import { StyledWhiteButton } from '@/operator/components/general/button/Styles';
import Button from '@mui/material/Button';
import { useTranslation } from 'react-i18next';
import { useOrgNavigate } from "app/routes/useOrgNavigate";
import styled from 'styled-components';
import { useAppContext } from '@/operator/context/AppContext';
import { CenterContentContainer } from './Styles';
import React from 'react';
import { appRoutes } from '@/routes/constants';
import { LoginActionType } from 'app/Pages/LoginPage';

type SignInDescriptionProps = {
    isTOS?: boolean;
};

export const StyledPurpleButton = styled(Button)`
    background-color: #4c17ad;
    &:disabled {
        background-color: #bf9dff;
    }
    & > div {
        margin-left: 15px !important;
    }
    @media (width <= 850px) {
        width: 100%;
    }
`;
export const StyledDivWrapper = styled.div`
    width: 60%;
    margin-top: 5px;
    @media (width <= 850px) {
        width: 80%;
    }
`;

const SignInDescription = ({ isTOS }: SignInDescriptionProps): JSX.Element => {
    const { t } = useTranslation();
    const navigate = useOrgNavigate();
    const { enableTOS, disableTOS } = useAppContext();

    const handleSignUp = () => {
        if (isTOS) {
            enableTOS();
        } else {
            disableTOS();
        }
        const signUpAction: LoginActionType = 'signUp';
        navigate(`${appRoutes.AUTH_LOGIN}?action=${signUpAction}`);
    };

    const handleLogin = async () => {
        if (isTOS) {
            enableTOS();
        }
        navigate(appRoutes.AUTH_SETUP_CHECKING);
    };

    return (
        <StyledDivWrapper>
            <CenterContentContainer>
                <Button
                    variant="contained"
                    size="large"
                    onClick={handleSignUp}
                    style={{
                        minWidth: '211px',
                        justifyContent: 'center',
                    }}
                >
                    {t('CommonWords.SignUpButton')}
                </Button>
                <StyledWhiteButton onClick={handleLogin}>
                    {t('CommonWords.LoginButton')}
                </StyledWhiteButton>
            </CenterContentContainer>
        </StyledDivWrapper>
    );
};

export default SignInDescription;
